import { apiClient } from '@/utils/api-client'
import { paginatedDirectoryParams } from '@/utils/paginated-directory-params'

const API_BASE = '/personal-access-tokens'

// Crockford Base32 — 26 chars, no I/L/O/U (case-insensitive: API returns lowercase ULIDs)
const ULID_RE = /^[0-9A-HJKMNP-TV-Z]{26}$/i

function assertUlid(value, name = 'id') {
    if (!ULID_RE.test(value)) {
        throw new Error(`Invalid ${name}: "${value}"`)
    }
}

class PersonalAccessTokenService {
    async list() {
        return await apiClient.get(API_BASE).then((response) => response.data)
    }

    async create(payload) {
        return await apiClient
            .post(API_BASE, payload)
            .then((response) => response.data)
    }

    async revoke(tokenUlid) {
        assertUlid(tokenUlid, 'tokenUlid')
        return await apiClient
            .delete(API_BASE + '/' + tokenUlid)
            .then((response) => response.data)
    }

    /**
     * Account-wide token directory. Paginated server-side — the response carries a
     * `meta` block ({ page, per_page, total, total_pages }) alongside `data`.
     *
     * @param {{page?: number, perPage?: number, status?: 'active'|'revoked'}} params
     */
    async directory(params = {}) {
        return await apiClient
            .get(API_BASE + '/directory', {
                params: paginatedDirectoryParams(params),
            })
            .then((response) => response.data)
    }

    async revokeForAdmin(tokenUlid) {
        assertUlid(tokenUlid, 'tokenUlid')
        return await apiClient
            .delete(API_BASE + '/directory/' + tokenUlid)
            .then((response) => response.data)
    }
}

export default new PersonalAccessTokenService()
